export * from "./useContestsBackendConfig";
